import React from 'react'
import { Box } from '@mui/material'

const InputGroup = ({ children, sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ...sx,
    }}
  >
    {children}
  </Box>
)

export default InputGroup
